module.exports = __webpack_public_path__ + "img/2Z.0c95d890.jpg";